/* eslint-disable no-unused-vars */
import Tag from "@shared/components/tag/Tag";
import {
  TAG_COLOR,
  TAG_SIZE,
  TAG_STYLE,
  TAG_TYPE,
} from "@shared/components/tag";
import { FC, ReactNode } from "react";
import {
  CERTIFICATE_LANG,
  CERTIFICATE_TONE,
} from "enums/certificate";

interface Props {
  icon: ReactNode;
  title: string;
  list: {
    name: string;
    id: CERTIFICATE_LANG | CERTIFICATE_TONE;
    icon?: FC<any>;
  }[];
  id: CERTIFICATE_LANG | CERTIFICATE_TONE | null;
  name: "tone" | "lang";
  handleSetting: (
    name: "tone" | "lang",
    id: CERTIFICATE_LANG | CERTIFICATE_TONE
  ) => void;
}

const SettingItem: FC<Props> = ({
  icon,
  title,
  list,
  name,
  id,
  handleSetting,
}) => {
  return (
    <div className="fds-sm:w-1/2 w-full">
      <div className="flex items-center gap-x-1.5  mb-2">
        {icon}
        <p className="text-fds-secondary body-sm">{title}</p>
      </div>
      <div className="flex gap-2">
        {list.map((tList, index) => (
          <Tag
            onClick={(e) => {
              e.preventDefault();
              handleSetting(name, tList.id);
            }}
            startIcon={tList.icon ? <tList.icon /> : undefined}
            key={index}
            style={id === tList.id ? TAG_STYLE.FILL : TAG_STYLE.OUTLINE}
            color={TAG_COLOR.DEFAULT}
            type={TAG_TYPE.ROUNDED}
            size={TAG_SIZE.MEDIUM}
          >
            {tList.name}
          </Tag>
        ))}
      </div>
    </div>
  );
};

export default SettingItem;
